import { OrderByPipe } from "./OrderByPipe";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RefUrlPipe } from "./ref-url.pipe";
import { SelectFilterComponent } from "./select-filter/select-filter.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ErrorStatusCodeTemplateComponent } from "./error-status-code-template/error-status-code-template.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { ValidationReportTableComponent } from "./validation-report-table/validation-report-table.component";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
  declarations: [
    OrderByPipe,
    RefUrlPipe,
    SelectFilterComponent,
    ErrorStatusCodeTemplateComponent,
    ValidationReportTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatTooltipModule
  ],
  exports: [OrderByPipe, RefUrlPipe, SelectFilterComponent, ValidationReportTableComponent],
})
export class SharedModule {}
